class Accordion extends HTMLElement {
  connectedCallback() {
    // Add event listener to handle click on collapsible buttons
    this.addEventListener('click', (event) => {
      const collapsibleButton = event.target.closest('collapsible-element button[aria-expanded]');
      if (!collapsibleButton) return;

      this.clickedCollapsible = collapsibleButton.closest('collapsible-element');
      this.closePeerCollapsibleElements();
    });
  }

  /**
   * Close peer collapsible elements
   */
  closePeerCollapsibleElements() {
    this.collapsibleElements =
      this.collapsibleElements || this.querySelectorAll('collapsible-element');

    if (this.clickedCollapsible.getAttribute('aria-hidden') === 'true') return;

    this.collapsibleElements.forEach((collapsible) => {
      if (collapsible !== this.clickedCollapsible) collapsible.close();
    });
  }
}

customElements.define('accordion-element', Accordion);
